import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('OnboardingPage').create(({ theme }) => ({
  root: {
    width: '100vw',
    height: '100vh',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },

  backgroundCurrent: {
    opacity: 1,
    zIndex: 1,
  },

  backgroundPrevious: {
    opacity: 0,
    zIndex: 2,
  },

  dotsContainer: {
    display: 'flex',
    gap: 8,
  },

  dot: {
    transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55)',
    transformOrigin: 'center',
  },

  activeDot: {
    width: 22,
    height: 6,
    borderRadius: 3,
    backgroundColor: 'white',
    transform: 'scale(1.1)',
    boxShadow: '0 0 8px rgba(255, 255, 255, 0.5)',
  },

  completedDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    transform: 'scale(1.05)',
  },

  inactiveDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    transform: 'scale(1)',
  },

  buttonContainer: {
    display: 'flex',
    position: 'absolute',
    padding: '0px 12px',
    width: '100%',
    flexDirection: 'column',
    bottom: '32px',
    left: '0',
    alignItems: 'center',
    gap: '16px',
    zIndex: 10,
  },

  heading: {
    fontFamily: 'Inter',
    position: 'absolute',
    fontWeight: '500',
    zIndex: '10',
    fontSize: theme.sizes.texts.fontSize.xl,
    textAlign: 'center',
    lineHeight: '85%',
    width: '75%',
    alignSelf: 'center',
    letterSpacing: '-2%',
    color: 'white',
  },

  overlayTop: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '25%',
    zIndex: 2,
    background: 'linear-gradient(to bottom, rgba(0,0,0,0.5), transparent)',
  },

  overlayBottom: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '40%',
    zIndex: 2,
    background: 'linear-gradient(to top, rgba(0,0,0,0.5), transparent)',
  },

  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundSize: '80vh',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: 0,
  },

  button: {
    width: '100%',
    height: theme.sizes.button.height,
    padding: '14px 24px',
    transition: 'transform 0.2s ease, opacity 0.2s ease',
    '&:active': {
      transform: 'scale(0.98)',
    },
    '&:disabled': {
      opacity: 0.8,
    },
  },
}))
